import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ReferenceField,
} from 'react-admin';

export default function ProfileList(props) {
  return (
    <List {...props} >
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="firstName" />
        <TextField source="lastName" />
        <ReferenceField source="userId" reference="users" linkType="show">
          <TextField source="username" />
        </ReferenceField>
        <TextField source="cellphone" />
        <TextField source="cpf" />
        <DateField source="createdAt" />
        <EditButton />
      </Datagrid>
    </List>
  );
}